var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var MaskField = function ($element) {
  this.mask = $element.attr("data-mask");
  if (this.mask) {
    $element.mask(this.mask, this.options);
  }
};

module.exports = MaskField;
